module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_fails.js
// module id = 10
// module chunks = 0